// TODO

const checkBoxStyle = ({
  spacing
}) => ({
  paddingLeft: spacing(1.75),
  // 14px
  paddingRight: spacing(),
  whiteSpace: 'nowrap',
  position: 'sticky',
  left: '0',
  background: 'white',
  zIndex: 100,
  minWidth: spacing(5)
});
const commonStyle = () => ({
  paddingRight: 0,
  minWidth: 180
});
const firstElementCommonStyle = theme => ({
  paddingRight: 0,
  paddingLeft: theme.spacing(3.25),
  // 26px
  minWidth: 180,
  '&:hover': {
    borderTopLeftRadius: 1,
    borderBottomLeftRadius: 1,
    borderColor: theme.palette.background.default
  }
});
const menuStyle = theme => ({
  paddingRight: 0,
  minWidth: 0,
  whiteSpace: 'nowrap',
  position: 'sticky',
  right: '0',
  background: theme.palette.background.paper,
  zIndex: 100
});
const getStyles = (isCheckbox, isMenu, isFirstElement) => {
  if (isCheckbox) {
    return checkBoxStyle;
  }
  if (isMenu) {
    return menuStyle;
  }
  if (isFirstElement) {
    return firstElementCommonStyle;
  }
  return commonStyle;
};
export { commonStyle, menuStyle, checkBoxStyle, getStyles };